/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class e{constructor(e){this.getUnmaskedRenderer=e}}function n(n){const r=n.getExtension("WEBGL_debug_renderer_info");return r?new e(()=>n.getParameter(r.UNMASKED_RENDERER_WEBGL)):null}export{e as RendererInfo,n as loadRendererInfo};
